var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorCoreValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3858 0H34.6142V58H23.3858V0Z",
    fill: "#7A69FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 23.3858V34.6142H0L4.90805e-07 23.3858L58 23.3858Z",
    fill: "#7A69FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5363 4.52409L53.4759 12.4637L12.4637 53.4759L4.52409 45.5363L45.5363 4.52409Z",
    fill: "#7A69FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4759 45.5363L45.5363 53.4759L4.5241 12.4637L12.4637 4.52409L53.4759 45.5363Z",
    fill: "#7A69FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorCoreValue);
export default __webpack_public_path__ + "static/media/vector-core-value.0e008e173aef91c182e22c9b9c5f73c4470c2b65ddae68e5a3074cc71840eaee.svg";
export { ForwardRef as ReactComponent };